import React, { useState } from 'react';
import { Card } from '@mui/material';

type TabType = 'Mission' | 'Vision' | 'Values' | null;

type DataType = {
  Mission: string[];
  Vision: string[];
  Values: string[];
};

const data: DataType = {
  Mission: [
    "High-quality assignment writing services",
    "Plagiarism-free content for students",
    "Expert writers supporting academic success",
  ],
  Vision: [
    "Empowering students globally",
    "Enhancing learning through innovative solutions",
    "Building trust with reliable services",
  ],
  Values: [
    "Integrity in every step",
    "Commitment to excellence",
    "Collaboration for better outcomes",
  ],
};

const MissionVisionValues = () => {
  const [activeTab, setActiveTab] = useState<TabType>(null);

  return (
    <Card className="w-full max-w-3xl mx-auto p-4 md:p-6 bg-[#f3f4f6]">
      <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6 w-full">
        {(Object.keys(data) as Array<keyof DataType>).map((key) => (
          <button
            key={key}
            onClick={() => setActiveTab(activeTab === key ? null : key)}
            className={`w-full sm:w-32 px-4 py-2 rounded-lg transition-all duration-300 ${
              activeTab === key
                ? 'bg-[#234152] text-white shadow-md hover:bg-[#f97316]'
                : 'bg-[#f97316] text-white hover:bg-blue-900 hover:text-white shadow-sm'
            }`}
          >
            {key}
          </button>
        ))}
      </div>

      {activeTab && (
        <div className="space-y-4">
          {data[activeTab].map((item: string, index: number) => (
            <div 
              key={index} 
              className="flex items-center bg-white p-3 rounded-lg shadow-sm"
            >
              <span className="font-bold text-orange-500 w-8 text-sm md:text-base shrink-0">
                {`0${index + 1}`}
              </span>
              <span className="text-gray-700 text-sm md:text-base whitespace-nowrap overflow-hidden text-ellipsis pr-4">
                {item}
              </span>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default MissionVisionValues;